import React from "react";
import { Link } from "react-router-dom";

/** StudyNotion wordmark — "Study" + yellow "Notion" (text only). */
export function BrandLogo({ asLink = true, className = "" }) {
  const inner = (
    <>
      <span className="font-semibold text-inherit">Study</span>
      <span className="font-bold text-yellow-50">Notion</span>
    </>
  );

  const base =
    "inline-flex select-none items-baseline gap-0 font-inter text-xl font-bold tracking-tight sm:text-2xl";

  if (asLink) {
    return (
      <Link
        to="/"
        aria-label="StudyNotion"
        className={`${base} rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-50 focus-visible:ring-offset-2 focus-visible:ring-offset-richblack-900 ${className}`}
      >
        {inner}
      </Link>
    );
  }

  return (
    <span className={`${base} ${className}`} aria-label="StudyNotion">
      {inner}
    </span>
  );
}

export default BrandLogo;
